// Auto-generated from newideaarchitect.com Wix site content (owned by the client)
export const wixImg = (id, w = 1440) => `https://static.wixstatic.com/media/${id}/v1/fit/w_${w},h_${w},q_80,enc_avif,quality_auto/${id}`;

export const CATEGORIES = [
  { key: "lakohazak", label: "Lakóházak" },
  { key: "tarsashazak", label: "Társasházak" },
  { key: "kozepuletek", label: "Középületek" },
];

export const PROJECTS = {
  "lakohazak": [
    {
      "slug": "hidegkuti-ut",
      "name": "Hidegkúti út",
      "cover": "58bce5_8f3498b4a6d644069b3408543b350301~mv2.jpg",
      "images": [
        "58bce5_8f3498b4a6d644069b3408543b350301~mv2.jpg",
        "58bce5_d3137f27f4124539898a2d7663c154aa~mv2.jpg",
        "58bce5_eb3d469a17af4f229b102b842c71e074~mv2.jpeg",
        "58bce5_39254b512daa4118b629070bca7dfdd6~mv2.jpeg",
        "58bce5_c551eeee4ebd4d698d17776e8e3959ea~mv2.jpeg",
        "58bce5_f6f236d82eee4ae4ad2b66b14fa2d950~mv2.jpeg",
        "58bce5_8f3498b4a6d644069b3408543b350301~mv2.webp",
        "58bce5_d3137f27f4124539898a2d7663c154aa~mv2.webp",
        "58bce5_eb3d469a17af4f229b102b842c71e074~mv2.webp",
        "58bce5_39254b512daa4118b629070bca7dfdd6~mv2.webp",
        "58bce5_c551eeee4ebd4d698d17776e8e3959ea~mv2.webp",
        "58bce5_f6f236d82eee4ae4ad2b66b14fa2d950~mv2.webp"
      ]
    },
    {
      "slug": "arvalanyhaj-utca",
      "name": "Árvalányhaj utca",
      "cover": "58bce5_6d8416cae8664a5b9644a95fe721a630~mv2.jpg",
      "images": [
        "58bce5_6d8416cae8664a5b9644a95fe721a630~mv2.jpg",
        "58bce5_f61361d4a93548f29c55079e3638d57a~mv2.jpg",
        "58bce5_6d8416cae8664a5b9644a95fe721a630~mv2.webp",
        "58bce5_f61361d4a93548f29c55079e3638d57a~mv2.webp"
      ]
    },
    {
      "slug": "panorama-utca",
      "name": "Panoráma utca",
      "cover": "58bce5_0f45eeda46cd411d9d99f6fd9b24eea8~mv2.jpg",
      "images": [
        "58bce5_0f45eeda46cd411d9d99f6fd9b24eea8~mv2.jpg",
        "58bce5_ca04f7c9d6534cb78212564e7528d609~mv2.jpeg",
        "58bce5_e3bbb54eead74dad88844b540094933a~mv2.jpg",
        "58bce5_1e03ac633e0149b5a11f4b0b480fbb8e~mv2.jpg",
        "58bce5_64ec10cf65f44ee89ce54b3325375321~mv2.jpeg",
        "58bce5_d61ccd392360412cb2f4c8443a37ecde~mv2.jpg",
        "58bce5_a1e689e39cdc4e4c98061c405e4029e6~mv2.jpg",
        "58bce5_9fde68de999d4fbfb2c93519e25e15fa~mv2.jpg",
        "58bce5_ca04f7c9d6534cb78212564e7528d609~mv2.webp",
        "58bce5_e3bbb54eead74dad88844b540094933a~mv2.webp",
        "58bce5_1e03ac633e0149b5a11f4b0b480fbb8e~mv2.webp",
        "58bce5_64ec10cf65f44ee89ce54b3325375321~mv2.webp",
        "58bce5_d61ccd392360412cb2f4c8443a37ecde~mv2.webp",
        "58bce5_a1e689e39cdc4e4c98061c405e4029e6~mv2.webp",
        "58bce5_9fde68de999d4fbfb2c93519e25e15fa~mv2.webp"
      ]
    },
    {
      "slug": "cseri-utca",
      "name": "Cseri utca",
      "cover": "58bce5_1d0db1dce4594d909ac8418c22a406b5~mv2.jpeg",
      "images": [
        "58bce5_1d0db1dce4594d909ac8418c22a406b5~mv2.jpeg",
        "58bce5_bb23032e1df7476eae798eb934df4296~mv2.jpeg",
        "58bce5_fdd821fcc0274e62ba5bd1621f84651a~mv2.jpeg",
        "58bce5_9581ba5a627241d196e9ee14b45655f7~mv2.jpeg",
        "58bce5_bb23032e1df7476eae798eb934df4296~mv2.webp",
        "58bce5_fdd821fcc0274e62ba5bd1621f84651a~mv2.webp",
        "58bce5_9581ba5a627241d196e9ee14b45655f7~mv2.webp"
      ]
    },
    {
      "slug": "pilisszentivan",
      "name": "Pilisszentiván",
      "cover": "58bce5_77999da426774d5cb6a445b1b57e926f~mv2.jpeg",
      "images": [
        "58bce5_77999da426774d5cb6a445b1b57e926f~mv2.jpeg",
        "58bce5_a3d1622b8b434a67b230530a9309f290~mv2.jpeg",
        "58bce5_a3d1622b8b434a67b230530a9309f290~mv2.webp"
      ]
    },
    {
      "slug": "muves-ut",
      "name": "Műves út",
      "cover": "58bce5_18fa33418d194dea8d057e108e749510~mv2.jpg",
      "images": [
        "58bce5_18fa33418d194dea8d057e108e749510~mv2.jpg",
        "58bce5_125c8649653440e2a26e58eec914bc39~mv2.jpg",
        "58bce5_18fa33418d194dea8d057e108e749510~mv2.webp",
        "58bce5_125c8649653440e2a26e58eec914bc39~mv2.webp"
      ]
    },
    {
      "slug": "szabo-lorinc-utca",
      "name": "Szabó Lőrinc utca",
      "cover": "58bce5_6470cc1d29274ca0a88997ede5aee5ca~mv2.jpeg",
      "images": [
        "58bce5_6470cc1d29274ca0a88997ede5aee5ca~mv2.jpeg",
        "58bce5_60f179b8bce640e1a6c915dfac921437~mv2.jpeg",
        "58bce5_bf5d5a0740d24243af73af759a6df124~mv2.jpg",
        "58bce5_5537677bc294461484a6909d30a588da~mv2.jpg",
        "58bce5_214c1f8cf59b4439ac3aa131b682eec5~mv2.jpg",
        "58bce5_3cfff22f658e4110b1c67ef7b3d958f8~mv2.jpg",
        "58bce5_a4166de1118c494c99f40825bc0e0583~mv2.jpg",
        "58bce5_d276b12b07644375acf13c6290d1e79d~mv2.jpg",
        "58bce5_60f179b8bce640e1a6c915dfac921437~mv2.webp",
        "58bce5_bf5d5a0740d24243af73af759a6df124~mv2.webp",
        "58bce5_5537677bc294461484a6909d30a588da~mv2.webp",
        "58bce5_214c1f8cf59b4439ac3aa131b682eec5~mv2.webp",
        "58bce5_3cfff22f658e4110b1c67ef7b3d958f8~mv2.webp",
        "58bce5_a4166de1118c494c99f40825bc0e0583~mv2.webp",
        "58bce5_d276b12b07644375acf13c6290d1e79d~mv2.webp"
      ]
    },
    {
      "slug": "mandulas-utca",
      "name": "Mandulás utca",
      "cover": "58bce5_81fc6b88ee1e4ad8aa072312e2b88e10~mv2.jpeg",
      "images": [
        "58bce5_81fc6b88ee1e4ad8aa072312e2b88e10~mv2.jpeg",
        "58bce5_671398dedaea4a3c95255870adea0615~mv2.jpeg",
        "58bce5_a3a9b5b99f664b4ba607bc515868af6c~mv2.jpeg",
        "58bce5_cb1b098219754221ba5a0ab28764859f~mv2.jpeg",
        "58bce5_671398dedaea4a3c95255870adea0615~mv2.webp",
        "58bce5_a3a9b5b99f664b4ba607bc515868af6c~mv2.webp",
        "58bce5_cb1b098219754221ba5a0ab28764859f~mv2.webp"
      ]
    },
    {
      "slug": "kisfaludy-utca",
      "name": "Kisfaludy utca",
      "cover": "58bce5_c9ce720298e544e2acb3adf9cd9980b7~mv2.jpeg",
      "images": [
        "58bce5_c9ce720298e544e2acb3adf9cd9980b7~mv2.jpeg",
        "58bce5_280d1be2534f4921b344cfb94b577d6d~mv2.jpeg",
        "58bce5_c9ce720298e544e2acb3adf9cd9980b7~mv2.webp",
        "58bce5_280d1be2534f4921b344cfb94b577d6d~mv2.webp"
      ]
    },
    {
      "slug": "fecske-13",
      "name": "Fecske 13",
      "cover": "58bce5_b3bde1756e914920984288c84949ccd6~mv2.jpeg",
      "images": [
        "58bce5_b3bde1756e914920984288c84949ccd6~mv2.jpeg",
        "58bce5_62c1b7016be44d96b2148db6df836777~mv2.jpeg",
        "58bce5_08c7025ec14a42ed87277b3831c55941~mv2.jpeg",
        "58bce5_b2c2eed84a034518916b337064fda6a0~mv2.jpg",
        "58bce5_6a240d0756fe4074a1fabe5621da94c6~mv2.jpg",
        "58bce5_f2989e9c6e324a5eb3f3a46f388a8fde~mv2.jpg",
        "58bce5_db94ca89200b4faf9dca8a604f5e1817~mv2.jpg",
        "58bce5_47909be3b16b43bd96f2c66645271b0b~mv2.jpeg",
        "58bce5_62c1b7016be44d96b2148db6df836777~mv2.webp",
        "58bce5_08c7025ec14a42ed87277b3831c55941~mv2.webp",
        "58bce5_b2c2eed84a034518916b337064fda6a0~mv2.webp",
        "58bce5_6a240d0756fe4074a1fabe5621da94c6~mv2.webp",
        "58bce5_f2989e9c6e324a5eb3f3a46f388a8fde~mv2.webp",
        "58bce5_db94ca89200b4faf9dca8a604f5e1817~mv2.webp",
        "58bce5_47909be3b16b43bd96f2c66645271b0b~mv2.webp"
      ]
    },
    {
      "slug": "iskola-utca",
      "name": "Iskola utca",
      "cover": "58bce5_e03ef48167544db88e2bc24fdea99a28~mv2.jpeg",
      "images": [
        "58bce5_e03ef48167544db88e2bc24fdea99a28~mv2.jpeg",
        "58bce5_070f065b93b3408a80c4170649760ed8~mv2.jpeg",
        "58bce5_d1679e04acd247f783396553656841a1~mv2.jpeg",
        "58bce5_79ad7f52c98d443381d5ce73966dcaf0~mv2.jpg",
        "58bce5_070f065b93b3408a80c4170649760ed8~mv2.webp",
        "58bce5_d1679e04acd247f783396553656841a1~mv2.webp",
        "58bce5_79ad7f52c98d443381d5ce73966dcaf0~mv2.webp"
      ]
    },
    {
      "slug": "csengele-tanya",
      "name": "Csengele tanya",
      "cover": "58bce5_13efc732620644b7978dd2920b55166b~mv2.jpeg",
      "images": [
        "58bce5_13efc732620644b7978dd2920b55166b~mv2.jpeg",
        "58bce5_769be109bf19476ea20d940154141da6~mv2.jpeg",
        "58bce5_13efc732620644b7978dd2920b55166b~mv2.webp",
        "58bce5_769be109bf19476ea20d940154141da6~mv2.webp"
      ]
    },
    {
      "slug": "kazmer-lejto-koncepcio",
      "name": "Kázmér Lejtő (Koncepció)",
      "cover": "58bce5_96fef79c7d924b2ea0f8d02a36be7fd6~mv2.jpeg",
      "images": [
        "58bce5_96fef79c7d924b2ea0f8d02a36be7fd6~mv2.jpeg",
        "58bce5_218cce556d8040bc802fd8eca0b94c9d~mv2.jpeg",
        "58bce5_218cce556d8040bc802fd8eca0b94c9d~mv2.webp"
      ]
    },
    {
      "slug": "tolgyfa-utca",
      "name": "Tölgyfa utca",
      "cover": "58bce5_41602c57510246c28457264b1450ff6b~mv2.jpeg",
      "images": [
        "58bce5_41602c57510246c28457264b1450ff6b~mv2.jpeg",
        "58bce5_cb71be38300d42fba158960d9b7634fd~mv2.jpeg",
        "58bce5_d6bed301c2274c308d510312e075b236~mv2.jpeg",
        "58bce5_c91cfd7782834873af37771361b79cec~mv2.jpg",
        "58bce5_ef020b77565c42199193c156e09fce92~mv2.jpg",
        "58bce5_5bbe4c080ba6432188a84f28ac253c85~mv2.jpg",
        "58bce5_542d1ba55539464989c72e79cc67530e~mv2.jpg",
        "58bce5_cb71be38300d42fba158960d9b7634fd~mv2.webp",
        "58bce5_d6bed301c2274c308d510312e075b236~mv2.webp",
        "58bce5_c91cfd7782834873af37771361b79cec~mv2.webp",
        "58bce5_ef020b77565c42199193c156e09fce92~mv2.webp",
        "58bce5_5bbe4c080ba6432188a84f28ac253c85~mv2.webp",
        "58bce5_542d1ba55539464989c72e79cc67530e~mv2.webp"
      ]
    },
    {
      "slug": "deindoll-dulo",
      "name": "Deindoll Dűlő",
      "cover": "58bce5_3adba10400a643148582471535341600~mv2.jpeg",
      "images": [
        "58bce5_3adba10400a643148582471535341600~mv2.jpeg",
        "58bce5_1ce0b09e8f1e46ce99de9e99edfd7db6~mv2.jpeg",
        "58bce5_1fe3af5db34a4f2f875efb6963b1aad6~mv2.jpeg",
        "58bce5_0077dea1dddc432889f468f2bc8e067a~mv2.jpeg",
        "58bce5_1ce0b09e8f1e46ce99de9e99edfd7db6~mv2.webp",
        "58bce5_1fe3af5db34a4f2f875efb6963b1aad6~mv2.webp",
        "58bce5_0077dea1dddc432889f468f2bc8e067a~mv2.webp"
      ]
    },
    {
      "slug": "pancel-koz",
      "name": "Páncél köz",
      "cover": "58bce5_5156e0b50077479cb95034ffe9a7f29f~mv2.jpg",
      "images": [
        "58bce5_5156e0b50077479cb95034ffe9a7f29f~mv2.jpg",
        "58bce5_dbc4a19dfa1047adb33f9007700a849b~mv2.jpeg",
        "58bce5_5156e0b50077479cb95034ffe9a7f29f~mv2.webp",
        "58bce5_dbc4a19dfa1047adb33f9007700a849b~mv2.webp"
      ]
    },
    {
      "slug": "vilagos-utca",
      "name": "Világos utca",
      "cover": "58bce5_0f21e435ddb74d40843fdb54e02e6b19~mv2.jpeg",
      "images": [
        "58bce5_0f21e435ddb74d40843fdb54e02e6b19~mv2.jpeg",
        "58bce5_0f21e435ddb74d40843fdb54e02e6b19~mv2.webp"
      ]
    },
    {
      "slug": "mely-utca",
      "name": "Mély utca",
      "cover": "58bce5_f7a7b68307bf48b98fafa00afd8da8c3~mv2.jpeg",
      "images": [
        "58bce5_f7a7b68307bf48b98fafa00afd8da8c3~mv2.jpeg",
        "58bce5_159ac266f57044a386d5ad55abe11d96~mv2.jpeg",
        "58bce5_ae881bcc9b824e76a0cd670c8141f885~mv2.jpeg",
        "58bce5_dcc295169f414a10b85edc727b0ce142~mv2.jpg",
        "58bce5_159ac266f57044a386d5ad55abe11d96~mv2.webp",
        "58bce5_ae881bcc9b824e76a0cd670c8141f885~mv2.webp",
        "58bce5_dcc295169f414a10b85edc727b0ce142~mv2.webp"
      ]
    },
    {
      "slug": "vasarhelyi-utca",
      "name": "Vásárhelyi utca",
      "cover": "58bce5_cf5627c5606b47448fae432bed3cf50b~mv2.jpg",
      "images": [
        "58bce5_cf5627c5606b47448fae432bed3cf50b~mv2.jpg",
        "58bce5_5cdafa637301481f8249c9def0bc912a~mv2.jpg",
        "58bce5_d2af76e6078149818f8275def5d1b076~mv2.jpg",
        "58bce5_5cdafa637301481f8249c9def0bc912a~mv2.webp",
        "58bce5_d2af76e6078149818f8275def5d1b076~mv2.webp"
      ]
    }
  ],
  "tarsashazak": [
    {
      "slug": "mikes-kelemen-ii",
      "name": "Mikes Kelemen II",
      "cover": "58bce5_37ca66b827e6408fb1c5bfb4ba0cd5ea~mv2.jpg",
      "images": [
        "58bce5_37ca66b827e6408fb1c5bfb4ba0cd5ea~mv2.jpg",
        "58bce5_172c24ddd94d4d95b75be4c33cd7464a~mv2.jpeg",
        "58bce5_eaf758ca74a6499c9e288858a87e787d~mv2.jpeg",
        "58bce5_711e43238571424bbd27e7510451287a~mv2.jpeg",
        "58bce5_172c24ddd94d4d95b75be4c33cd7464a~mv2.webp",
        "58bce5_eaf758ca74a6499c9e288858a87e787d~mv2.webp",
        "58bce5_711e43238571424bbd27e7510451287a~mv2.webp"
      ]
    },
    {
      "slug": "zakany-utca",
      "name": "Zákány utca",
      "cover": "58bce5_6d87bf986a3b429e8d014b51d5afdc5b~mv2.jpeg",
      "images": [
        "58bce5_6d87bf986a3b429e8d014b51d5afdc5b~mv2.jpeg",
        "58bce5_fd7672289ae744f7ba2e0b381bc5a2e4~mv2.jpeg",
        "58bce5_6d87bf986a3b429e8d014b51d5afdc5b~mv2.webp",
        "58bce5_fd7672289ae744f7ba2e0b381bc5a2e4~mv2.webp"
      ]
    },
    {
      "slug": "fecske38",
      "name": "Fecske38",
      "cover": "58bce5_59fa65e80be24d919f0a9d1c7f9150b8~mv2.jpeg",
      "images": [
        "58bce5_59fa65e80be24d919f0a9d1c7f9150b8~mv2.jpeg",
        "58bce5_aaa2c30f42ab4fe6b739a7b1aac69934~mv2.jpeg",
        "58bce5_62b90f4dd9c5452292e23c33beec90a2~mv2.jpeg",
        "58bce5_8fc56608e3d3474aaea24b8aa1a63b9d~mv2.jpeg",
        "58bce5_1e99ae9977fb4a5b9f33db826597f065~mv2.jpeg",
        "58bce5_0526a26532554b0fb6b10086b47994f1~mv2.jpg",
        "58bce5_acafd1cd1c9b4b1bab4d63746bd7d060~mv2.jpg",
        "58bce5_17e17f1bb323435aabb5e1db66818b19~mv2.jpg",
        "58bce5_457e646e1901490ea4008a03792e891d~mv2.jpg",
        "58bce5_aaa2c30f42ab4fe6b739a7b1aac69934~mv2.webp",
        "58bce5_62b90f4dd9c5452292e23c33beec90a2~mv2.webp",
        "58bce5_8fc56608e3d3474aaea24b8aa1a63b9d~mv2.webp",
        "58bce5_1e99ae9977fb4a5b9f33db826597f065~mv2.webp",
        "58bce5_0526a26532554b0fb6b10086b47994f1~mv2.webp",
        "58bce5_acafd1cd1c9b4b1bab4d63746bd7d060~mv2.webp",
        "58bce5_17e17f1bb323435aabb5e1db66818b19~mv2.webp",
        "58bce5_457e646e1901490ea4008a03792e891d~mv2.webp"
      ]
    },
    {
      "slug": "nyarfa-setany",
      "name": "Nyárfa sétány",
      "cover": "58bce5_7627ba83414c448482a5862679867c85~mv2.jpg",
      "images": [
        "58bce5_7627ba83414c448482a5862679867c85~mv2.jpg",
        "58bce5_88ed244b890f43419e465fccd79f7ab4~mv2.jpg",
        "58bce5_bc980be8a9294036b5edee1272fb683b~mv2.jpg",
        "58bce5_7627ba83414c448482a5862679867c85~mv2.webp",
        "58bce5_88ed244b890f43419e465fccd79f7ab4~mv2.webp",
        "58bce5_bc980be8a9294036b5edee1272fb683b~mv2.webp"
      ]
    },
    {
      "slug": "hetvezer-utca",
      "name": "Hétvezér utca",
      "cover": "58bce5_72d87bd6eaaa44da8fd1b2f75991035b~mv2.jpeg",
      "images": [
        "58bce5_72d87bd6eaaa44da8fd1b2f75991035b~mv2.jpeg",
        "58bce5_72d87bd6eaaa44da8fd1b2f75991035b~mv2.webp"
      ]
    },
    {
      "slug": "fenyves-utca",
      "name": "Fenyves utca",
      "cover": "58bce5_f1e5f570ad124e69bb91a1926bcd926f~mv2.jpeg",
      "images": [
        "58bce5_f1e5f570ad124e69bb91a1926bcd926f~mv2.jpeg",
        "58bce5_ba707e0b8aa94d3ba68300476325f7fd~mv2.jpeg",
        "58bce5_ba707e0b8aa94d3ba68300476325f7fd~mv2.webp"
      ]
    },
    {
      "slug": "mikes-kelemen-i",
      "name": "Mikes Kelemen I",
      "cover": "58bce5_38de39047c32438da89bb3475219bf9f~mv2.jpeg",
      "images": [
        "58bce5_38de39047c32438da89bb3475219bf9f~mv2.jpeg",
        "58bce5_501385fda8ab4cf18e2e8408a34e8350~mv2.jpeg",
        "58bce5_7f6699f7112244f1a5ec8bc577ce49a2~mv2.jpeg",
        "58bce5_24a436af56bf46c88678edcce1fa337a~mv2.jpeg",
        "58bce5_501385fda8ab4cf18e2e8408a34e8350~mv2.webp",
        "58bce5_7f6699f7112244f1a5ec8bc577ce49a2~mv2.webp",
        "58bce5_24a436af56bf46c88678edcce1fa337a~mv2.webp"
      ]
    },
    {
      "slug": "vilagos-utca-th",
      "name": "Világos utca",
      "cover": "58bce5_0f21e435ddb74d40843fdb54e02e6b19~mv2.jpeg",
      "images": [
        "58bce5_0f21e435ddb74d40843fdb54e02e6b19~mv2.jpeg",
        "58bce5_0f21e435ddb74d40843fdb54e02e6b19~mv2.webp"
      ]
    }
  ],
  "kozepuletek": [
    {
      "slug": "mvm-bekescsaba",
      "name": "MVM Békéscsaba",
      "cover": "58bce5_9df76b3a4aa14f929476a642a35ec925~mv2.jpg",
      "images": [
        "58bce5_9df76b3a4aa14f929476a642a35ec925~mv2.jpg",
        "58bce5_00f8873f46fc4faab70ad41a99415128~mv2.jpg",
        "58bce5_7f4cc6f88b2549bd97af262a0b8da65b~mv2.jpg",
        "58bce5_e3b0c93307e44b3db3e3f4a2dd7ce407~mv2.jpg",
        "58bce5_00f8873f46fc4faab70ad41a99415128~mv2.webp",
        "58bce5_7f4cc6f88b2549bd97af262a0b8da65b~mv2.webp",
        "58bce5_e3b0c93307e44b3db3e3f4a2dd7ce407~mv2.webp"
      ]
    },
    {
      "slug": "hableany-panzio",
      "name": "Hableány Panzió",
      "cover": "58bce5_1d0c641358ce48b69bab6684411c09dc~mv2.jpeg",
      "images": [
        "58bce5_1d0c641358ce48b69bab6684411c09dc~mv2.jpeg",
        "58bce5_0f1a7b60c13f4b2fa066fdd770578dee~mv2.jpeg",
        "58bce5_56a575fa403842b7a6c58189c47abc1a~mv2.jpeg",
        "58bce5_9414820facb14622b138bf7ee468b060~mv2.jpeg",
        "58bce5_d3516ccadb7f44f58e913d93d1aef6d0~mv2.jpeg",
        "58bce5_09b46d5453784c2897efa55a39f3bd66~mv2.jpeg",
        "58bce5_4229f0d674bc482ba924418e4e75e609~mv2.jpeg",
        "58bce5_31437d0fb033492b9ec00e4d55540707~mv2.jpeg",
        "58bce5_437b31898bfc43b688691703e33bb9e8~mv2.jpeg",
        "58bce5_15dd4beeee87426c825e8eda7d2ffe8a~mv2.jpeg",
        "58bce5_0f1a7b60c13f4b2fa066fdd770578dee~mv2.webp",
        "58bce5_56a575fa403842b7a6c58189c47abc1a~mv2.webp",
        "58bce5_9414820facb14622b138bf7ee468b060~mv2.webp",
        "58bce5_d3516ccadb7f44f58e913d93d1aef6d0~mv2.webp",
        "58bce5_09b46d5453784c2897efa55a39f3bd66~mv2.webp",
        "58bce5_4229f0d674bc482ba924418e4e75e609~mv2.webp",
        "58bce5_31437d0fb033492b9ec00e4d55540707~mv2.webp",
        "58bce5_437b31898bfc43b688691703e33bb9e8~mv2.webp",
        "58bce5_15dd4beeee87426c825e8eda7d2ffe8a~mv2.webp"
      ]
    },
    {
      "slug": "kistelek-rendezvenyhaz",
      "name": "Kistelek rendezvényház",
      "cover": "58bce5_e4c0671de93d4c18b33bb81dc7504c44~mv2.jpeg",
      "images": [
        "58bce5_e4c0671de93d4c18b33bb81dc7504c44~mv2.jpeg",
        "58bce5_87e5a216d299424c8563f32a3acb0059~mv2.jpeg",
        "58bce5_ab3815f9480b497fbdbd6b665583518f~mv2.jpeg",
        "58bce5_87e5a216d299424c8563f32a3acb0059~mv2.webp",
        "58bce5_ab3815f9480b497fbdbd6b665583518f~mv2.webp"
      ]
    },
    {
      "slug": "regiposta-utca",
      "name": "Régiposta utca",
      "cover": "58bce5_2a0dd2da980049ab97a62222be081399~mv2.jpg",
      "images": [
        "58bce5_2a0dd2da980049ab97a62222be081399~mv2.jpg",
        "58bce5_ed8a060ca25c489a893a14578f9f07af~mv2.jpg",
        "58bce5_44df450fab2e4ec4bdbe0dc44e827282~mv2.jpg",
        "58bce5_ed8a060ca25c489a893a14578f9f07af~mv2.webp",
        "58bce5_44df450fab2e4ec4bdbe0dc44e827282~mv2.webp"
      ]
    },
    {
      "slug": "keszhtely-munkasszallo",
      "name": "Keszhtely munkásszálló",
      "cover": "58bce5_f66c8f746a5f4a9f849e77f9e053eb8e~mv2.jpeg",
      "images": [
        "58bce5_f66c8f746a5f4a9f849e77f9e053eb8e~mv2.jpeg",
        "58bce5_086b29032d004fd68b496a276a00146d~mv2.jpeg",
        "58bce5_086b29032d004fd68b496a276a00146d~mv2.webp"
      ]
    },
    {
      "slug": "piac-utca",
      "name": "Piac utca",
      "cover": "58bce5_6e19ee458b9144a09c4bcd040d4c0cd5~mv2.jpeg",
      "images": [
        "58bce5_6e19ee458b9144a09c4bcd040d4c0cd5~mv2.jpeg",
        "58bce5_73e4b2dd849f4e479bc4b813e8cfd6dc~mv2.jpeg",
        "58bce5_6e19ee458b9144a09c4bcd040d4c0cd5~mv2.webp",
        "58bce5_73e4b2dd849f4e479bc4b813e8cfd6dc~mv2.webp"
      ]
    }
  ]
};
